function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { useClassPrepend } from "../../../../hook/ui/common/className/useClassPrepend";
import "./unstyledTableHeader.css";

/*
    Returns a list of table column labels, and optionally custom content around each label

    props
        (string, required) minWidth   The minimum width of the whole table header
        (array, required)  columns    A list of column config objects
                                        - Example = [
                                            { 
                                                dataKey: "name",                                   // (string, required)      The object key to use for each row
                                                label: "Name",                                     // (any, required)         The displayed column label
                                                columnStyles: { minWidth: "250px", width: "80%" }, // (object, required)      The sizing of the column
                                                renderCell: (cell, row) => cell.toUpperCase()      // (function, optional)    A function to do some custom rendering in each body row cell
                                                alignContent: "right",                             // (string, optional)      This example makes the column right aligned (left align is default)
                                                headerCellContentLeft: <span>Left</span>,          // (any, optional)         The content to show to the left of the label
                                                headerCellContentTop: <span>Top</span>,            // (any, optional)         ```
                                                headerCellContentRight: <span>Right</span>,        // (any, optional)         ```
                                                headerCellContentBottom: <span>Bottom</span>,      // (any, optional)         ```
                                            },
                                            { 
                                                dataKey: "count", 
                                                label: "Count", 
                                                columnStyles: { minWidth: "100px", width: "20%" }
                                            }
                                        ]
*/

const UnstyledTableHeader = ({
  classPrepend = "unstyled",
  columns,
  minWidth,
  // props to exclude from ...rest that are passed from wrapper components
  noDataMessage,
  onRowClick,
  enablePagination,
  expandedRowRender = null,
  ...rest
}) => {
  const [getClassName, getClassNameWithGlobal] = useClassPrepend(classPrepend);
  return /*#__PURE__*/React.createElement("div", _extends({}, getClassNameWithGlobal("table-header"), {
    style: {
      minWidth: minWidth
    }
  }, rest), columns.map((column, cIndex) => {
    let cellContentAlignClassname = "";
    if (column?.headerAlignContent === "right") {
      cellContentAlignClassname = "table-header-cell-right-align";
    }
    if (column?.headerAlignContent === "center") {
      cellContentAlignClassname = "table-header-cell-center-align";
    }
    return /*#__PURE__*/React.createElement("div", _extends({
      key: cIndex
    }, getClassNameWithGlobal("table-header-cell"), {
      style: column.columnStyles && column.columnStyles
    }), /*#__PURE__*/React.createElement("div", getClassNameWithGlobal(`table-header-cell-content ${cellContentAlignClassname}`), /*#__PURE__*/React.createElement("div", getClassNameWithGlobal("table-header-cell-content-left"), column.headerCellContentLeft && column.headerCellContentLeft), /*#__PURE__*/React.createElement("div", getClassNameWithGlobal("table-header-cell-content-center-column"), /*#__PURE__*/React.createElement("div", getClassNameWithGlobal("table-header-cell-content-top"), column.headerCellContentTop && column.headerCellContentTop), /*#__PURE__*/React.createElement("div", getClassNameWithGlobal("table-header-cell-label"), column.label), /*#__PURE__*/React.createElement("div", getClassNameWithGlobal("table-header-cell-content-bottom"), column.headerCellContentBottom && column.headerCellContentBottom)), /*#__PURE__*/React.createElement("div", getClassNameWithGlobal("table-header-cell-content-right"), column.headerCellContentRight && column.headerCellContentRight)));
  }));
};
export { UnstyledTableHeader };